<script setup>
import { brand, footerData } from '../../config/pageData.js';
</script>

<template>
  <footer class="m-footer">
    <div class="m-footer-brand">
      <img
        :src="brand.logoLight"
        alt="楓燧堂"
        class="m-footer-logo"
      />
      <span>{{ footerData.copyright }}</span>
    </div>
    <p class="m-footer-note">{{ footerData.disclaimer }}</p>
  </footer>
</template>

<style scoped lang="scss">
.m-footer {
  background: #101a15;
  color: #7d7970;
  padding: 52px 32px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 18px;
}

.m-footer-brand {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 26px;
  color: #7d7970;
}

.m-footer-logo {
  width: 60px;
  height: 60px;
}

.m-footer-note {
  font-size: 24px;
  line-height: 1.6;
  color: #7d7970;
}
</style>
